export default __webpack_public_path__ + "static/media/Clan Bound Gloves of the Mound.e17868d8.jpg";